var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary","disabled":!_vm.aplicacao.valida},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarSalvar()}}},[_c('span',[_c('i',{staticClass:"fa fa-floppy-o"}),_vm._v(" Salsasvar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }